export enum BankaccountableType {
  COMPANY = 'App\\Models\\Company',
}
